import React from 'react';
import styles from './Feed.module.scss';
import Story from '../Story';
import { withPrefix } from 'gatsby';

const Feed = ({ edges, title, slugsHref }) => {
    const [slugs, setSlugs] = React.useState([])

    const slugsNotInEdges = (slugsa, edgesa) => {
        return slugsa.filter(slug => !edgesa.some(edge => edge.node.fields.slug === slug));
    }

    if (slugsHref) {
        React.useEffect(() => {
            fetch(slugsHref)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const exclusiveSlugs = slugsNotInEdges(json, edges);
                    setSlugs(exclusiveSlugs);
                });
        }, []);
    }

    return (
        <>
            <h2 className={styles.h2}>{title}</h2>
            <div className={styles.grid}>
                {edges && edges.map(edge => <Story key={edge.node.fields.slug} className={styles.story} edge={edge} />)}
                {slugs && slugs.map(slug => <Story key={slug} className={styles.story} path={withPrefix(slug)} />)}
            </div>
        </>
    );
}

export default Feed;
